<template>
  <div class="autocomplete" v-click-outside="hideSelector">
    <input type="text" v-model="initialText" v-on:click="openselector" class="form-control secondary" v-bind:placeholder="placeholder">
    <div v-if="optionValues.length > 0" class="list-container">
      <ul>
        <li v-for="value in optionValues" v-on:click="setValue(value)">{{value.text}}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Autocomplete',
  props: ['setvalue', 'value', 'placeholder', 'values', 'initdata'],
  data: function()
  {
    return {initialText: '', timer: false, nochange: false, optionValues: [], optionset: false};
  },
  created: function()
  {
    var me = this;
  },
  watch:
  {
    value: function(val)
    {
      var me = this;
      if(val != '' && me.nochange == false) me.initdata({query: val, initialId: me.value, start: 0, limit: 20});
    },
    initialText: function(val)
    {
      var me = this;

      if(me.timer != false)
      {
        clearTimeout(me.timer);
        me.timer = false;
      }
      if(me.nochange == false)
      {
        me.timer = setTimeout(function()
        {
          me.optionValues = [];
          me.initdata({query: val, initialId: me.value, start: 0, limit: 20});
        }, 300);
      }
      me.nochange = false;
    },
    values: function(val)
    {
      var me = this;

      if(me.optionset == false && me.value != '')
      {
        for(var i=0;i<val.length;i++)
        {
          if(val[i].value == me.value)
          {
            me.setValue(val[i]);
          }
        }
        me.optionset = true;
      }
      else
      {
        me.optionValues = [];
        for(var i=0;i<val.length;i++)
        {
          me.optionValues.push(val[i]);
        }
      }
    }
  },
  methods:
  {
    hideSelector()
    {
      var me = this;
      console.log('click outside')
      me.optionValues = [];
    },
    setValue(value)
    {
      var me = this;
      me.setvalue(value.value);
      me.initialText = value.text;
      me.optionValues = [];
      me.nochange = true;
    },
    openselector: function()
    {
      var me = this;
      me.optionValues = [];
      me.initdata({initialId: me.value, start: 0, limit: 20});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lib/Autocomplete.vue